import React, { useCallback, useEffect, useRef, useState } from "react";
import { Trash2 } from "lucide-react";
import { deleteImage, getImages, uploadMedia } from "../../services/servicesblogs";
import "./Images.css";

export default function Images() {
  const fileInputRef = useRef(null);
  const [media, setMedia] = useState([]);

  // âœ… FIXED NORMALIZER (IMPORTANT)
  const normalizeMedia = (item) => {
    const src =
      item?.url ??
      item?.fileUrl ??
      item?.secure_url ??
      item?.imageUrl ??
      item?.src ??
      "";

    return {
      id: item?.id || item?._id || `${Date.now()}-${Math.random()}`,
      name: item?.name || item?.filename || "uploaded-file",
      src,

      // âœ… FIX: use src instead of item.url
      type:
        item?.type ||
        (src.match(/\.(mp4|webm|ogg)$/i) ? "video" : "image"),

      uploadedPretty: item?.createdAt
        ? new Date(item.createdAt).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
          })
        : "",
    };
  };

  const loadMedia = useCallback(async () => {
    try {
      const payload = await getImages();

      const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
          ? payload.data
          : [];

      const normalized = list
        .map(normalizeMedia)
        .filter((item) => item.src !== "");

      setMedia(normalized);
    } catch (error) {
      console.error("Error loading media:", error);
      setMedia([]);
    }
  }, []);

  useEffect(() => {
    loadMedia();
  }, [loadMedia]);

  const handleDelete = async (id) => {
    try {
      await deleteImage(id);
      await loadMedia();
    } catch (error) {
      window.alert(error?.response?.data?.message || "Failed to delete file.");
    }
  };

  const openFileExplorer = () => {
    fileInputRef.current?.click();
  };

  const handleUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    try {
      await Promise.all(files.map((file) => uploadMedia(file)));
      await loadMedia();
    } catch (error) {
      window.alert(error?.response?.data?.message || "Upload failed.");
    }

    e.target.value = "";
  };

  return (
    <>
      <div className="cm-top">
        <div>
          <h1>Media Manager</h1>
          <p className="page-subtitle">{media.length} files uploaded</p>
        </div>
        <button className="primary-btn" onClick={openFileExplorer}>
          Upload Media
        </button>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/png,image/jpeg,image/webp,video/mp4,video/webm,video/ogg"
        multiple
        className="hidden-file-input"
        onChange={handleUpload}
      />

      {media.length === 0 ? (
        <section className="image-manager-box">
          <div className="image-empty-state">
            <div className="image-empty-icon">MEDIA</div>
            <h4>No media uploaded</h4>
            <p>Upload images or videos to use in your blog posts</p>
          </div>
        </section>
      ) : (
        <section className="image-grid">
          {media.map((item) => (
            <article key={item.id} className="image-card">
              <div className="image-thumb-wrap">
                {item.type === "image" ? (
                  <img src={item.src} alt={item.name} />
                ) : (
                  <video controls width="100%">
                    <source src={item.src} type="video/mp4" />
                  </video>
                )}

                <div className="image-hover-actions">
                  <button
                    type="button"
                    className="image-action-btn delete"
                    onClick={() => handleDelete(item.id)}
                    title="Delete"
                  >
                    <Trash2 size={20} />
                  </button>
                </div>
              </div>

              <div className="image-card-info">
                <p className="image-name">{item.name}</p>
                <div className="image-meta">
                  <span>Uploaded</span>
                  <span>{item.uploadedPretty}</span>
                </div>
              </div>
            </article>
          ))}
        </section>
      )}
    </>
  );
}
